import { useContext, useState } from "react";
import { Stack, TextField, Box, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
//Date
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//import from project
import "./dashboardstyle.scss";
// import EmptyData from "../Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import { currencyFormat } from "../../Function/DynamicFn";
import useGetTotalRevenueByType from "../../Hooks/useGetTotalRevenueByType";
import { AuthContext } from "../../Context/AuthContext";

export default function TotalRevenueByType() {
  const { t } = useContext(AuthContext);
  const [filterMonth, setFilterMonth] = useState(moment().format("YYYY-MM-DD"));
  const { tableData, loading } = useGetTotalRevenueByType({ filterMonth });

  // console.log("tableData::", tableData);

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "50%",
        dataLabels: {
          position: "top", // Always outside
          // style: {
          //   fontSize: "16px",
          // },
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: 15, // Bigger offset to push labels away from bar
      style: {
        colors: ["#000"], // Black text
        fontSize: "14px",
        fontWeight: "bold",
      },
      textAnchor: "start", // Always align labels to the left edge
      formatter: function (val) {
        return "$ " + currencyFormat(val);
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const category =
          w.globals.initialSeries[seriesIndex].data[dataPointIndex].x;
        const value = series[seriesIndex][dataPointIndex];
        return `<div style="padding:5px;">
                <strong>${category}</strong>: $${currencyFormat(value)}
              </div>`;
      },
    },
  };

  const series = [
    {
      data: [
        {
          x: "Piano",
          y: tableData?.totalPiano || 0,
          fillColor: "#4b50b6",
        },
        {
          x: "Guitar, violin",
          y: tableData?.totalGuitar || 0,
          fillColor: "#4dc4d9",
        },
        {
          x: "Drum, Bass",
          y: tableData?.totalDrum || 0,
          fillColor: "#40d388",
        },
        {
          x: "Online Class",
          y: tableData?.totalByOnlineClass || 0,
          fillColor: "#f19251",
        },
        { x: "Book", y: tableData?.totalByBook || 0, fillColor: "#4b50b6" },
        {
          x: "Instrument",
          y: tableData?.totalByInstrument || 0,
          fillColor: "#4dc4d9",
        },
        {
          x: "Total",
          y: tableData?.totalAmount || 0,
          fillColor: "#40d388",
        },
      ],
    },
  ];

  return (
    <Stack className="chart-container" direction="column" spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography className="chart-title">{t("total_revenue")}</Typography>

        <Box sx={{ width: "220px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year", "month"]}
              value={
                filterMonth
                  ? dayjs(moment(filterMonth).format("YYYY-MM"))
                  : null
              }
              className="select-date"
              slotProps={{
                textField: {
                  fullWidth: true,
                  InputProps: {
                    sx: {
                      "& input": {
                        width: "100%",
                        padding: "8.5px 14px",
                        fontFamily: "'PublicSans', 'Siemreap', sans-serif",
                      },
                    },
                  },
                },
              }}
              onChange={(val) => {
                if (val) {
                  setFilterMonth(new Date(val));
                } else {
                  setFilterMonth("");
                }
              }}
            />
          </LocalizationProvider>
        </Box>
      </Stack>

      {loading ? (
        <Stack
          direction="column"
          justifyContent="center"
          sx={{ height: "360px" }}
        >
          <LoadingPage />
        </Stack>
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={360}
        />
      )}
    </Stack>
  );
}
